/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './DataManagementView.scss';
import BasePanel from '../../Panels';
import ManagePoi from '../../Panels/ManagePoi';
import ManageHotel from '../../Panels/ManageHotel';
import ManageData from '../../Panels/ManageData';
import AddLayers from './AddLayers';

class DataManagementView extends React.Component {
  render() {
    return (
      <div>
        <div className="col-sm-12">
          <div>
            <BasePanel
              fullWidth
              user={this.props.user}
              userHasFeatureCode="0003"
              panelType="warning"
              panelTitle="Zarządzanie punktami POI"
            >
              <ManagePoi />
            </BasePanel>
            <BasePanel
              fullWidth
              user={this.props.user}
              userHasFeatureCode="0003"
              panelType="warning"
              panelTitle="Zarządzanie noclegami"
            >
              <ManageHotel />
            </BasePanel>
            <BasePanel
              fullWidth
              user={this.props.user}
              userHasFeatureCode="0008"
              panelType="warning"
              panelTitle="Edycja atrybutów warstwy"
            >
              <ManageData user={this.props.user} />
            </BasePanel>
            <BasePanel user={this.props.user} userHasFeatureCode="0003" style={{textAlign: "center"}} panelType="danger" panelTitle="Definiowanie warstw">
              <AddLayers />
            </BasePanel>
          </div>
        </div>
      </div>
    );
  }
}

DataManagementView.PropTypes = {
  viewName: PropTypes.string.isRequired,
  viewDesc: PropTypes.string.isRequired,
};

export default withStyles(s)(DataManagementView);



// WEBPACK FOOTER //
// src/components/Modals/Settings/SettingsViews/DataManagementView/DataManagementView.js